import { useEffect } from 'react';
import { dependenciesApi } from '../api/dependencies.api';
import { STATUS } from '../interfaces/dependencies.interface';
import { useDataTable } from '../../../hooks/useDataTable';
export const useDependencies = () => {
  const table = useDataTable(dependenciesApi);
  const { setDataFilters } = table;
  useEffect(() => {
    setDataFilters([
      {
        filter: 'status',
        value_filter: '',
        data: STATUS,
        width: 'col-span-3 max-[768px]:col-span-12',
      },
    ]);
  }, []);
  return {
    ...table,
  };
};
